import CatalogSwiper from '~/src/common/components/CatalogSwiper';
import CardDispatcher from '~/src/common/components/ProductsGrid/CardDispatcher';
import { useGetCategory } from '~/src/queries/api-ecom/generated/api-ecom';
import { ProductPlaceholder } from '~/src/screens/CatalogContent/ListProductsScreen/layout';

import { PropsFromInputs } from '../../types';

import { Container } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ categoryID, simulateCatalogPadding }: Props) => {
  const { data, refetch } = useGetCategory(categoryID);

  return (
    <Container $simulateCatalogPadding={simulateCatalogPadding}>
      <CatalogSwiper>
        {data?.items.map(product => (
          <CardDispatcher
            key={product.id}
            product={product}
            onRefresh={refetch}
            eventSource="products list"
            source={{
              type: 'products list' as const,
              detail: {
                categoryId: categoryID,
              },
            }}
            analyticsProperties={{}}
          />
        )) ?? [
          <ProductPlaceholder key="placeholder1" />,
          <ProductPlaceholder key="placeholder2" />,
          <ProductPlaceholder key="placeholder3" />,
          <ProductPlaceholder key="placeholder4" />,
          <ProductPlaceholder key="placeholder5" />,
          <ProductPlaceholder key="placeholder6" />,
          <ProductPlaceholder key="placeholder7" />,
          <ProductPlaceholder key="placeholder8" />,
        ]}
      </CatalogSwiper>
    </Container>
  );
};
